// src/components/Footer.tsx
import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3>About Us</h3>
              <p>New ABC Montessori is dedicated to providing a nurturing environment where children can grow, learn, and explore their potential through our innovative educational programs.</p>
              <div className="footer-social">
                <a href="#facebook" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="#twitter" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="#instagram" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="#youtube" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
            <div className="footer-column">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#home"><i className="fas fa-chevron-right"></i> Home</a></li>
                <li><a href="#about"><i className="fas fa-chevron-right"></i> About Us</a></li>
                <li><a href="#our_classes"><i className="fas fa-chevron-right"></i> Our Classes</a></li>
                <li><a href="#teachers"><i className="fas fa-chevron-right"></i> Teachers</a></li>
                {/* <li><a href="#gallery"><i className="fas fa-chevron-right"></i> Gallery</a></li>
                <li><a href="#blog"><i className="fas fa-chevron-right"></i> Blog</a></li> */}
              </ul>
            </div>
            <div className="footer-column">
              <h3>Newsletter</h3>
              <p>Subscribe to our newsletter for the latest updates and news.</p>
              <form className="newsletter-form">
                <input type="email" placeholder="Your Email" required />
                <button type="submit"><i className="fas fa-paper-plane"></i></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} New ABC Montessori. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;